<template>
    <section class="tip" :style="styles" :class="{ loading: loading }">
        <transition name="fade" appear>
            <div class="container" v-if="product">
                <h2 class="month-tip-heading">{{ title }}</h2>
                <div class="row">
                    <div class="col-lg-5 col-md-5">
                        <a :href="product.detail_url"
                           class="js-ga-event"
                           data-page-area="tip-mesiaca"
                           data-type="product"
                           :data-name="product.name"
                           data-action="href"
                           :data-destination-url="product.detail_url"
                        >
                            <figure class="tip-img">
                                <img :src="product.image_url" loading="lazy" :alt="product.name">
                                <div class="tip-badge" :style="{ backgroundColor: badgeBgColor, color: badgeTextColor }">
                                    <img :src="badgeImg"
                                         loading="lazy"
                                         alt="Vesnala"
                                    >
                                    <span class="value">{{ badgeMainText }}</span>
                                    <span class="text">{{ badgeSecondaryText }}</span>
                                </div>
                            </figure>
                        </a>
                    </div>
                    <div class="col-lg-4 col-md-7">
                        <div class="tip-text">
                            <h4>{{ product.name }}</h4>
                            <p class="excerpt">{{ product.tag_text }}</p>
                            <div class="description" v-html="product.preview_text"></div>
                            <span class="tip-price-old hidden-md-up" v-if="product.default_price && product.price < product.default_price">
                                {{ parseFloat(product.default_price).toFixed(2) }} {{ currency }}
                            </span>
                            <span class="tip-price hidden-md-up">
                                {{ parseFloat(product.price).toFixed(2) }} {{ currency }}
                            </span>

                            <add-to-cart
                                :btn-text="buttonText"
                                :product-id-p="product.id"
                                class="hidden-md-up"
                                data-page-area="tip-mesiaca"
                            >
                            </add-to-cart>
                        </div>
                    </div>
                    <div class="col-lg-2 offset-lg-1 hidden-md-down">
                        <span class="tip-price-old" v-if="product.default_price && product.price < product.default_price">
                            {{ parseFloat(product.default_price).toFixed(2) }} {{ currency }}
                        </span>
                        <span class="tip-price">
                            {{ parseFloat(product.price).toFixed(2) }} {{ currency }}
                        </span>
                        <add-to-cart
                            :btn-text="buttonText"
                            :product-id-p="product.id"
                            data-page-area="tip-mesiaca"
                        >
                        </add-to-cart>
                    </div>
                </div>
            </div>
        </transition>

        <template v-if="loading">
            <ComponentLoader />
        </template>
    </section>

</template>

<script>
import { onMounted, ref, inject, toRefs } from 'vue'
import axios from 'axios'

import ComponentLoader from '../globals/ComponentLoader'
import AddToCart from '../buttons/AddToCart'

export default {

    props: [
        'title',
        'styles',
        'productId',
        'badgeBgColor',
        'badgeTextColor',
        'badgeImg',
        'badgeMainText',
        'badgeSecondaryText',
        'buttonText',
        'apiRoute'
    ],

    components: {
        ComponentLoader,
        AddToCart
    },

    setup(props) {

        const product   = ref(null)
        const loading   = ref(true)
        const constants = inject('constants')

        onMounted( () => fetchProduct())

        function fetchProduct() {
            axios.post(props.apiRoute, { id: props.productId })
                .then( response => {
                    if ( response.status === 200 ) {
                        product.value = response.data.product
                        loading.value = false
                    }
                    else
                        flash('Niečo sa pokazilo', 'danger')
                })
                .catch( error => flash(error.message, 'danger'))
        }

        return {
            ...toRefs(constants),
            product,
            loading,
        }
    }
}
</script>
